import { registerComponent } from '@gig/magic-common';
import SearchFieldComponent from './search-field.vue.js';

var SearchField = registerComponent(SearchFieldComponent);

export { SearchField };
